var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Icons_Clipboard1_LTR",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.764 55.3C55.8901 56.3942 55.916 58.1941 54.8218 59.3202 54.8028 59.3397 54.7835 59.359 54.764 59.378L49.882 60.986 49.021 60.125 50.629 55.243C51.7949 54.138 53.629 54.1633 54.764 55.3ZM76.824 25.831 48.624 54.094 45 65.007 55.97 61.388 84.176 33.188Z",
    stroke: "#FFFFFF",
    strokeWidth: 0.999808,
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.318 23.767 86.24 19.689C85.3564 18.7849 83.9072 18.7683 83.0031 19.6519 82.9906 19.6641 82.9782 19.6765 82.966 19.689L78.945 23.71 86.24 31 90.26 26.98C91.1619 26.1865 91.2497 24.8122 90.4563 23.9104 90.4124 23.8605 90.3663 23.8126 90.318 23.767Z",
    stroke: "#FFFFFF",
    strokeWidth: 0.999808,
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 65 41.842 65 43.168 61 26 61 26 65Z",
    stroke: "#FFFFFF",
    strokeWidth: 0.999808,
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 41 57.448 41 61.44 37 26 37 26 41Z",
    stroke: "#FFFFFF",
    strokeWidth: 0.999808,
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70 51.6 70 82 20 82 20 20 31 20 31 26 59 26 59 20 70 20 70 28.422 74.7 23.71 74.7 23.71 74.871 23.539 76 22.41 76 18C76 15.7909 74.2091 14 72 14L55 14 55 12C55 9.79086 53.2091 8 51 8L39 8C36.7909 8 35 9.79086 35 12L35 14 18 14C15.7909 14 14 15.7909 14 18L14 84C14 86.2091 15.7909 88 18 88L72 88C74.2091 88 76 86.2091 76 84L76 45.6ZM42.864 12.864C43.4291 12.2979 44.2002 11.986 45 12 46.6569 12 48 13.3431 48 15 48 16.6569 46.6569 18 45 18 43.3431 18 42 16.6569 42 15 41.986 14.2002 42.2979 13.4291 42.864 12.864Z",
    stroke: "#FFFFFF",
    strokeWidth: 0.999808,
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26 53 45.448 53 49.44 49 26 49 26 53Z",
    stroke: "#FFFFFF",
    strokeWidth: 0.999808,
    fill: "#FFFFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.1d3a66fb0d384463a5da65a2978adcc2.svg";
export { ForwardRef as ReactComponent };